export default __webpack_public_path__ + "static/media/SOLACE.032a43ce.png";